<template>
  <v-sheet
    v-if="!this.skeletonLoaded"
    light
    color="grey lighten-4"
    class="px-1 py-1"
    :height="1200"
  >
    <v-skeleton-loader
      class="mx-auto"
      :type="skeletonSettings.type"
      :max-height="skeletonSettings.maxHeight"
    ></v-skeleton-loader>
  </v-sheet>
  <div v-else>
  <v-row class="void mt-7">
    <v-flex xs12 md12 lg8 :class="[!isMobile && 'pr-7']">
      <v-card :min-height="dashboardCardsMinHeight">
      <v-progress-linear
          top
          color="primary accent-4"
          :active="isLoading"
          indeterminate
          rounded
          height="3"
        ></v-progress-linear>
        <v-row class="justify-space-between">
          <v-card-title class="">Последняя проверка</v-card-title>
          <v-btn color="light-green" dark class="ma-4" @click="startDataExpertChecking" v-if="showStartButton">
              Начать
              <v-icon
                right
                dark
              >
                mdi-play-circle-outline
              </v-icon></v-btn>
          <v-btn color="red" class="ma-4" dark @click="stopDataExpertChecking" v-if="showStopButton">
          Отменить
          <v-icon
            right
            dark
          >
            mdi-stop-circle-outline
          </v-icon></v-btn>
        </v-row>
        <v-row class="void pb-2">
          <v-flex xs6 >
            <v-card-title class="justify-right">{{ lastReportDate }}</v-card-title>
            <v-card-subtitle class="text-left">{{ nextReportDate }}</v-card-subtitle>
          </v-flex> 
          <v-flex xs3 >
            <v-card-title class="justify-center pb-0" v-if="isStatusVisible">
              <v-icon size="18" :color="lastReportStatus.color" class="mr-3">{{ lastReportStatus.icon }}</v-icon>
              {{ lastReportStatus.text }}
            </v-card-title>
            <v-card-subtitle class="text-center pt-4 text-caption text-truncate" v-if="sessionId">{{ sessionId }}</v-card-subtitle>
          </v-flex> 
          <v-flex xs3 v-if="reportDownloadsAvailable">
            <v-card-title class="justify-end pb-0">
              Отчеты
            </v-card-title>
            <div class="text-right pr-2" v-if="reportDownloadsAvailable">
              <template v-for="(report) in downloadableReports">
                <v-btn
                @click="downloadReport(report)"
                v-bind:key="report.type"
                icon
                color="light-grey">
                  <v-icon>{{ getReportIcon }}</v-icon>
                </v-btn>
              </template>
            </div>
          </v-flex> 
        </v-row>
        <v-divider ></v-divider>
        <v-card-text class="pt-2">
            <v-card flat class="d-flex align-center" height="120" v-if="showProgressBar">
                <v-progress-linear
                  color="primary accent-4"
                  :value="progress"
                  rounded
                  height="25"
                  active="true"
                >
                  <strong>{{ Math.ceil(progress) }}%</strong>
                </v-progress-linear>
            </v-card>
            <v-row class="d-flex align-end" v-if="showStatisticsBar">
              <v-flex lg3 class="void">
                <v-list-item-content class="void">
                      <v-list-item-subtitle
                        :class="[
                          'text-center',
                          'text-h4',
                          'text-darken-1',
                          'font-weight-bold',
                        ]"
                      >
                        {{ checksCount }}
                      </v-list-item-subtitle>
                      <v-list-item-title
                        class="mt-4 grey--text font-weight-medium text-center"
                      >
                        проверок
                      </v-list-item-title>
                    </v-list-item-content>
              </v-flex>    
              <v-flex lg3 class="void">
                <v-list-item-content class="void">
                      <v-list-item-subtitle
                        :class="[
                          'text-center',
                          'text-h4',
                          'text-darken-1',
                          'font-weight-bold',
                        ]"
                      >
                        {{ screenshotsCount }}
                      </v-list-item-subtitle>
                      <v-list-item-title
                        class="mt-4 grey--text font-weight-medium text-center"
                      >
                        скриншотов
                      </v-list-item-title>
                    </v-list-item-content>
                </v-flex>
              <v-flex lg3 class="void">
                <v-list-item-content class="void">
                      <v-list-item-subtitle
                        :class="[
                          'text-center',
                          'text-h4',
                          'text-darken-1',
                          'font-weight-bold',
                        ]"
                      >
                        {{ rrpViolations }}
                      </v-list-item-subtitle>
                      <v-list-item-title
                        class="mt-4 grey--text font-weight-medium text-center"
                      >
                        нарушений РРЦ 
                        <v-tooltip right max-width="250">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="ml-1" v-bind="attrs" v-on="on" size="14"
                              >mdi-progress-question</v-icon
                            >
                          </template>
                          <span>Здесь показаны товары, где ваша цена ниже чем у определенного продавца или вашего поставщика.</span>
                        </v-tooltip>
                      </v-list-item-title>
                    </v-list-item-content>
                </v-flex>  
                <v-flex lg3 class="void">
                      <pie-chart
                        v-if="isPositionsChartVisible"
                        :chartData="chartData"
                        :options="chartOptions"
                        :styles="pieStyles">
                      </pie-chart> 
                      <v-list-item-subtitle
                        v-else
                        :class="[
                          'text-center',
                          'text-h4',
                          'text-darken-1',
                          'font-weight-bold',
                        ]"
                      >
                        —
                      </v-list-item-subtitle>
                      <v-list-item-title
                        class="mt-2 grey--text font-weight-medium text-center"
                      >
                        Позиции
                        <v-tooltip right max-width="250">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="ml-1" v-bind="attrs" v-on="on" size="14"
                              >mdi-progress-question</v-icon
                            >
                          </template>
                          <span>Позиции вашего магазина среди других продавцов. Позиция 6 означает что ваш магазин не найден среди первой пятерки продавцов.</span>
                        </v-tooltip>
                      </v-list-item-title>
                </v-flex>
            </v-row>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 md12 lg4 :class="[isMobile && 'pt-7']">
      <v-card :min-height="dashboardCardsMinHeight" >
        <v-card-title class="justify-center">Баланс</v-card-title>
        <v-card-subtitle class="text-center">Доступно проверок</v-card-subtitle>
        <v-card-text>
          <v-list-item-subtitle
            :class="[
              'mt-2',
              'text-center',
              isMobile ? 'text-h4' : 'text-h3',
              'blue--text text--darken-1',
              'font-weight-bold',
            ]"
          >
              {{
                checksLeft
              }}
            </v-list-item-subtitle>
            <v-card-subtitle class="text-center pt-1" v-if="daysLeft">~{{ daysLeft }} дней</v-card-subtitle>
        </v-card-text>
        <v-card-actions  class="justify-center d-flex align-end mt-5">
            <v-btn class="mb-8 pl-10 pr-10" color="primary" @click="showPaymentsPopup">Пополнить</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-row>
  <v-row class="void mt-7">
    <v-flex xs12>
      <v-card class="pa-4">
        <data-expert-table :items="reportItems" :loading="reportTableLoading"/>
      </v-card>
    </v-flex>
  </v-row>
  <data-expert-prices-popup @onPaymentSuccessful="onPaymentSuccessful"></data-expert-prices-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ScreenResolutionMixin from "@/mixins/ScreenResolution";
import FormatMixin from "@/mixins/Format";
import PieChart from "@/plugins/charts/PieCharts.js";
import DataExpertPricesPopup from "@/components/popups/service-modals/DataExpertPricesPopup";
import DataExpertTable from "@/components/tables/DataExpertTable";

export default {
  components: {
    PieChart,
    DataExpertPricesPopup,
    DataExpertTable,
  },
  mixins: [ScreenResolutionMixin, FormatMixin],
  data() {
    return {
      skeletonLoaded: false,
      unsubscribe: null,
      skeletonSettings: {
        type: "table-row, card@6",
        maxHeight: "100vh",
      },
      hexColors: {
        mediumOrange: "#fba276",
        chartGreen: "#7BB21A",
        red: "#E46651",
      },
      dashboardCardsMinHeight: 350
    };
  },
  computed: {
    ...mapGetters("profile", {
      company: "company",
    }),
    ...mapGetters("dataExpert", {
      dataExpert: "dataExpertDashboard",
      dataExpertItems: "dataExpertItems",
      isFetching: "isFetching",
      isFetchingItems: "isFetchingItems",
    }),
    pieStyles() {
      return {
        height: `75px`,
        position: "relative",
        padding: "0",
      };
    },
    chartOptions() {
      return {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          bodyFontSize: 14
        }
      };
    },
    positionsData() {
      let latestPositions = this.dataExpert?.latestCheck?.positions;
      if (latestPositions && Object.keys(latestPositions).length) {
        return latestPositions;
      } else {
        return {
            1: 0,
            2: 0,
            3: 0,
            4: 0,
            5: 0,
            6: 0
          }
      }
    },
    chartData() {
      const { group } =
        //this.productsStats.general.productPositions || {};
        {
          group: this.positionsData 
        };

      return {
          labels: ["  1 позиция", "  2 позиция", "  3 позиция", "  4 позиция", "  5 позиция", "  6 позиция"],
          datasets: [
            {
              backgroundColor: [
                this.hexColors.chartGreen,
                this.hexColors.mediumOrange,
                this.hexColors.red,
                this.hexColors.red,
                this.hexColors.red,
                this.hexColors.red
              ],
              borderWidth: 0,
              data: [...Object.values(group)],
            },
          ],
      };
    },
    lastReportDate() {
      if (this.dataExpert?.latestCheck?.dateCreated) {
        return this.dateTextFormat(this.dataExpert?.latestCheck?.dateCreated);
      } else {
        return "Проверки еще небыло"
      }
    },
    nextReportDate() {
      if (this.dataExpert?.nextCheck?.datePlanned) {
        return `Следующая: ${this.dateTextFormatWeekday(this.dataExpert?.nextCheck?.datePlanned)}`;
      } else {
        return "Следующая: Не запланирована"
      }
    },
    isStatusVisible() {
      return this.dataExpert?.latestCheck?.status?.length || false;
    },
    lastReportStatus() {
      switch (this.dataExpert?.latestCheck?.status) {
        case "IDLE": return {icon: "mdi-rocket-outline", color: "grey", text: "Подготовка"};
        case "STARTED": return {icon: "mdi-autorenew", color: "light-blue", text: "В процессе"};
        case "PROCESSING": return {icon: "mdi-autorenew", color: "light-blue", text: "В процессе"};
        case "COMPLETED": return {icon: "mdi-check-circle", color: "green", text: "Завершено"};
        case "ERROR": return {icon: "mdi-alert-circle", color: "red", text: "Ошибка"};
        case "CANCELLED": return {icon: "mdi-close-circle", color: "grey", text: "Отменено"};
        default: return {icon: "", color: "grey", text: "Неизвестно"}
      }
    },
    downloadableReports() {
      return this.dataExpert?.latestCheck?.reports || []
    },
    reportDownloadsAvailable() {
      return ["COMPLETED"].includes(this.dataExpert?.latestCheck?.status) && this.downloadableReports.length > 0;
    },
    getReportIcon(report) {
      switch (report?.type) {
        case "XLSX": return "mdi-file-excel-outline";
        default: return "mdi-file-excel-outline";
      }
    },
    checksCount() {
      return this.dataExpert?.latestCheck?.checksCount || 0;
    },
    screenshotsCount() {
      return this.dataExpert?.latestCheck?.screenshotsCount || 0;
    },
    rrpViolations() {
      if (this.dataExpert?.latestCheck?.rrpViolations) {
        return this.dataExpert?.latestCheck?.rrpViolations;
      } else {
        return "—";
      }
    },
    isPositionsChartVisible() {
      let { positions } = this.dataExpert?.latestCheck || {};
      return positions !== undefined && Object.keys(positions).length;
    },
    checksLeft() {
      let checksLeft = this.dataExpert?.balance?.checksLeft || 0;
      return this.formattedNumber(checksLeft);
    },
    daysLeft() {
      return this.dataExpert?.balance?.daysLeft || 0;
    },
    sessionId() {
      return this.dataExpert?.latestCheck?.sessionId?.split("_")[1] || "";
    },
    showStatisticsBar() {
      return ["COMPLETED"].includes(this.dataExpert?.latestCheck?.status);
    },
    showProgressBar() {
      return this.dataExpert?.latestCheck?.progress !== undefined && ["IDLE", "STARTED", "PROCESSING"].includes(this.dataExpert?.latestCheck?.status);
    },
    progress() {
      return this.dataExpert?.latestCheck?.progress || 0;
    },
    showStartButton() {
      return !this.dataExpert?.latestCheck || ["COMPLETED", "ERROR", "CANCELLED"].includes(this.dataExpert?.latestCheck?.status) && !this.isFetching && this.dataExpert?.balance?.checksLeft; 
    },
    showStopButton() {
      return ["IDLE", "STARTED", "PROCESSING"].includes(this.dataExpert?.latestCheck?.status) && !this.isFetching; 
    },
    isLoading() {
      console.log(`this.isFetching ${this.isFetching}`)
      return this.isFetching === true;
    },
    reportItems() {
      return this.dataExpertItems;
    },
    reportTableLoading() {
      return this.isFetchingItems;
    }
  },
  methods: {
    fetchDataExpertDashboard() {
      this.$store.dispatch("dataExpert/fetchDataExpertDashboard");
    },
    fetchDataExpertItems() {
      this.$store.dispatch("dataExpert/fetchDataExpertItems");
    },
    downloadReport(report) {
      this.navigateTo(report.url)
    },
    navigateTo(url) {
      window.open(url, "_blank");
    },
    showPaymentsPopup() {
      this.$store.commit("serviceModals/DISPLAY_DATAEXPERT_PRICES_MODAL");
    },
    onPaymentSuccessful(data) {
      this.$store.dispatch("dataExpert/increaseBalance", data.addedChecks);
    },
    startDataExpertChecking() {
      this.$store.dispatch("dataExpert/startDataExpertJob");
    },
    stopDataExpertChecking() {
      this.$store.dispatch("dataExpert/stopDataExpertJob");
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === "dataExpert/SET_DATAEXPERT_DASHBOARD") {
        this.skeletonLoaded = true;
      }
    });
    this.fetchDataExpertDashboard();
    this.fetchDataExpertItems();
  },
  beforeDestroy() {
    this.unsubscribe && this.unsubscribe();
  },
};
</script>